import { render } from "./ModifiersPlugin.vue?vue&type=template&id=532a96ff"
import script from "./ModifiersPlugin.vue?vue&type=script&lang=js"
export * from "./ModifiersPlugin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__